









import { Component, Vue } from 'vue-property-decorator';
import Leaflets from '@/components/Leaflets.vue';
import QRCode from '@/components/QRCode.vue';
import Navbar from '@/components/Navbar.vue';
import TrainInfo from '@/components/TrainInfo.vue';

@Component({
  components: {
    Leaflets,
    QRCode,
    TrainInfo,
    Navbar
  }
})
export default class SplitTrain extends Vue {}
